import { render, staticRenderFns } from "./FormPhoneInput.vue?vue&type=template&id=5c8d6d6f&scoped=true"
import script from "./FormPhoneInput.vue?vue&type=script&lang=js"
export * from "./FormPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./FormPhoneInput.vue?vue&type=style&index=0&id=5c8d6d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d6d6f",
  null
  
)

export default component.exports